import React from "react";

interface props {
    instagram: string;
    facebook: string;
    twitter: string;
    tiktok: string
}
export default function SocialMediaIcons({instagram, facebook, twitter, tiktok}: props){

    const formatLink = (url: string, base: string): string | null => {
        if (!url || url.length <= 3) return null
        // Clean @ and any leading slashes or whitespace
        const clean = url.replace(/^@/, '').replace(/^\/+/, '').trim();
        return url.startsWith('http') ? url : `${base}${clean}`
    }

    const links = {
        instagram: formatLink(instagram, 'https://www.instagram.com/'),
        facebook: formatLink(facebook, 'https://www.facebook.com/'),
        twitter: formatLink(twitter, 'https://www.x.com/'),
        tiktok: formatLink(tiktok, 'https://www.tiktok.com/'),
    }

    return (
        <div className="flex justify-evenly">
            {links.instagram && (
                <a href={links.instagram} className="mx-1 cursor-pointer" target="_blank" rel="noopener noreferrer">
                    <img 
                            src={require('../../../assets/icons/instagram-icon.png')}
                            className="w-6 h-6 lg:w-7 lg:h-7 text-main-green-900 cursor-pointer hover:text-main-green-500 hover:opacity-80"
                            alt="Instagram icon" 
                    />
                </a>
            )}
            {links.facebook && (
                <a href={links.facebook} className="mx-1 cursor-pointer" target="_blank" rel="noopener noreferrer">
                    <img 
                        src={require('../../../assets/icons/facebook-icon.png')}
                        className="w-6 h-6 lg:w-7 lg:h-7 text-main-green-900 cursor-pointer hover:text-main-green-500"
                        alt="Facebook icon" 
                    />
                </a>
            )}
            {links.twitter && (
                <a href={links.twitter} className="mx-1 cursor-pointer" target="_blank" rel="noopener noreferrer">
                    <img 
                        src={require('../../../assets/icons/twitter-icon.png')}
                        className="w-6 h-6 lg:w-7 lg:h-7 text-main-green-900 cursor-pointer hover:text-main-green-500" 
                        alt="Twitter/X icon"
                    />
                </a>
            )}
            {links.tiktok && (
                <a href={links.tiktok} className="mx-1 cursor-pointer" target="_blank" rel="noopener noreferrer">
                    <img 
                        src={require('../../../assets/icons/tiktok-icon.png')}
                        className="w-6 h-6 lg:w-7 lg:h-7 text-main-green-900 cursor-pointer hover:text-main-green-500" 
                        alt="TikTok icon"
                    />
                </a>
            )}
        </div>
    )
}